import { Button } from '@mui/material'
import { useState } from 'react'
import { ApplyBureauSubscriptionPlansConfirm, useDontShowAgain } from './CustomerBureauApplySubscriptionPlansConfirm'

interface ForceSaveSubscriptionPlanProps {
  onSave: () => void
  disabled?: boolean
}

export const ApplyBureauSubscriptionPlans = ({ onSave, disabled }: ForceSaveSubscriptionPlanProps) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  const show = useDontShowAgain()

  const handleSave = () => {
    onSave()
    setDialogOpen(false)
  }

  const handleClick = () => {
    if (!show.show) {
      return handleSave()
    }

    setDialogOpen(true)
  }

  return (
    <>
      <ApplyBureauSubscriptionPlansConfirm show={show} open={dialogOpen} onConfirm={handleSave} onClose={() => setDialogOpen(false)} />
      <Button disabled={disabled} variant="secondary" onClick={handleClick}>
        Apply subscription plans
      </Button>
    </>
  )
}
